import marketFiltersDesktopGrid from '@/components/market/market-filters/market-filters-desktop-grid/market-filters-desktop-grid.vue';

export default {
  components: {
    marketFiltersDesktopGrid,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
      default: 0,
    },
    layout: {
      type: String,
      default: 'grid',
    },
  },
  data() {
    return {
      currentLayout: this.layout,
    };
  },
  methods: {
    switchLayoutClicked(layout) {
      this.currentLayout = layout;
      this.$emit('toggle', layout);
    },
    classModifier(layout) {
      return {
        'market-list-desktop-header__switch-button': true,
        [`market-list-desktop-header__switch-button--${layout}`]: true,
        'market-list-desktop-header__switch-button--active': this.currentLayout === layout,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-list-desktop-header/market-list-desktop-header.js